import { createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../helper/axiosInstance";
import { Constants } from "../utils/Constants";
import { toast } from "react-toastify";

const initialState = {
  getAllStaticsLoading: false,
  getAllStaticsData: [],
  getAllStaticsError: "",
  totalAdminPage: 0,
  allAdminData: [],
  AdminPaginationDataLength: 0,
  adminStartedRecords: 1,
  adminToRecords: 20,

  allAdminDataBanking: [],
  AdminPaginationDataLengthBanking: 0,
  adminStartedRecordsBanking: 1,
  adminToRecordsBanking: 20,

  //
  getAllUserAccountLoading: false,
  getAllUsersData: [],
  getAllUsersFailed: "",
  //
  getBankingDataLoading: false,
  getBankingData: [],
  getBankingDataError: "",
  // Banking statatics 
  getBankingStaticsLoading: false,
  getBankingStatics: [],
  getBankingStaticsError: "",
  isBankingFiterApply:false,
  waivePenaltyLoading:false,
  waivePenaltyData:null,
  waivePenaltyError:null,

  // Global Platform Fee (12%) toggle
  platformFeeEnabled: true,
  platformFeeLoading: false,
  platformFeeError: null,
  updatePlatformFeeLoading: false,

};

export const staticsSlice = createSlice({
  name: "statics",
  initialState,
  reducers: {
    // Total
    getAllAdminSuccess: (state, action) => {
      state.getAllStaticsLoading = false;
      state.allAdminData = action.payload;
      console.log("mac", action.payload);
      state.AdminPaginationDataLength =
        action.payload[action.payload.length - 1];
      state.adminStartedRecords =
        (action.payload.CurrentPage - 1) * Constants.TAKE + 1;
      state.adminToRecords = Math.min(
        action.payload.CurrentPage * Constants.TAKE,
        action.payload[action.payload.length - 1]
      );
      state.totalAdminPage = Math.ceil(
        action.payload[action.payload.length - 1] / Constants.TAKE
      );
    },
    getAllAdminBankingSuccess: (state, action) => {

      state.getAllStaticsLoading = false;
      state.allAdminDataBanking = action.payload[0];
      state.AdminPaginationDataLengthBanking =
        action.payload[action.payload.length - 1];
      state.adminStartedRecordsBanking =
        (action.payload.CurrentPage - 1) * Constants.TAKE + 1;
      state.adminToRecordsBanking = Math.min(
        action.payload.CurrentPage * Constants.TAKE,
        action.payload[action.payload.length - 1]
      );
      state.totalAdminPageBanking = Math.ceil(
        action.payload[action.payload.length - 1] / Constants.TAKE
      );
    },

    GetStatics: (state) => {
      state.getAllStaticsLoading = true;
    },
    GetStaticsSuccess: (state, action) => {
      state.getAllStaticsLoading = false;
      state.getAllStaticsData = action.payload;
    },
    GetStaticsFailed: (state, action) => {
      state.getAllStaticsLoading = false;
      state.getAllStaticsError = action.payload;
    },
    // Users
    GetAlluserDetail: (state) => {
      state.getAllUserAccountLoading = true;
    },
    GetAllUserDetailSuccess: (state, action) => {
      state.getAllUsersData = action.payload[0];
      console.log("action.payloadS", action.payload);
      state.AdminPaginationDataLength =
        action.payload[action.payload.length - 1];
      state.adminStartedRecords =
        (action.payload.CurrentPage - 1) * Constants.TAKE + 1;
      state.adminToRecords = Math.min(
        action.payload.CurrentPage * Constants.TAKE,
        action.payload[action.payload.length - 1]
      );
      state.totalAdminPage = Math.ceil(
        action.payload[action.payload.length - 1] / Constants.TAKE
      );
      // state.getAllUsersData = action.payload?.filter((Data) => {
      //   return (
      //     Data.TotalBusiness !== 0 ||
      //     Data?.TotalCustomers !== 0 ||
      //     Data?.TotalProjects !== 0
      //   );
      // });
      state.getAllUserAccountLoading = false;
    },
    GetAllUserDetailFailed: (state, action) => {
      state.getAllUserAccountLoading = false;
      state.getAllUsersFailed = action.payload;
    },
    // Banking
    GetBankingDetail: (state) => {
      state.getBankingDataLoading = true;
    },
    GetBankingDetailSuccess: (state, action) => {
      console.log('action.payload',action.payload?.bankingFilter);
      state.isBankingFiterApply= action.payload?.bankingFilter
      state.getBankingDataLoading = false;
      state.getBankingData = action.payload;
    },
    GetBankingDetailFailed: (state, action) => {
      state.getBankingDataLoading = false;
      state.getBankingDataError = action.payload;
    },
    // Bacnking Statics 
    GetBankingStatatics: (state) => {
      state.getBankingStaticsLoading = true;
    },
    GetBankingStataticsSuccess: (state, action) => {
      console.log('getBankingStatics',action.payload);
      
      state.getBankingStaticsLoading = false;
      state.getBankingStatics = action.payload;
    },
    GetBankingStataticsFailed: (state, action) => {
      state.getBankingStaticsLoading = false;
      state.getBankingStaticsError = action.payload;
    },
    WaivePenaltyLoading: (state) => {
      state.waivePenaltyLoading = true;
    },
    WaivePenaltySuccess: (state, action) => {
      console.log('action.payloadWaivePenalty', action.payload);
     const filter = state?.allAdminDataBanking?.map(row=>{
      if (row.id === action.payload.rowId) {
        return {
          ...row,
          Amount: '00.0'
        }
     }
     return row
    })
      state.allAdminDataBanking = filter;
      state.waivePenaltyLoading = false;
      state.waivePenaltyData = action.payload;
    },
    WaivePenaltyFailed: (state, action) => {
      console.log('action.payloadWaivePenaltyFailed', action.payload);
      state.waivePenaltyLoading = false;
      state.waivePenaltyData = action.payload;
    },

    GetPlatformFeeConfigLoading: (state) => {
      state.platformFeeLoading = true;
      state.platformFeeError = null;
    },
    GetPlatformFeeConfigSuccess: (state, action) => {
      state.platformFeeLoading = false;
      state.platformFeeEnabled = !!action.payload?.platformFeeEnabled;
    },
    GetPlatformFeeConfigFailed: (state, action) => {
      state.platformFeeLoading = false;
      state.platformFeeError = action.payload;
    },
    UpdatePlatformFeeConfigLoading: (state) => {
      state.updatePlatformFeeLoading = true;
    },
    UpdatePlatformFeeConfigSuccess: (state, action) => {
      state.updatePlatformFeeLoading = false;
      state.platformFeeEnabled = !!action.payload?.platformFeeEnabled;
    },
    UpdatePlatformFeeConfigFailed: (state) => {
      state.updatePlatformFeeLoading = false;
    },

    UserBlockUnBlock: (state, action) => {
      console.log('action.UserBlockUnBlock', action.payload);
    
      const rowExists = state.allAdminDataBanking.some(
        (row) => row.id === action.payload.id
      );
    console.log('rowExists',rowExists);
    
      if (rowExists) {
        state.allAdminDataBanking = state.allAdminDataBanking.map((row) => {
          if (row.id === action.payload.id) {
            return {
              ...row,
              ...action.payload,
            };
          }
          return row; 
        });
      } else {
        state.allAdminDataBanking = [
          action.payload,
          ...state.allAdminDataBanking,
        ];
      }
    },
    
  },
});

export const getAllStaticsDataAsync = (data) => (dispatch) => {
  dispatch(GetStatics());
  axiosInstance
    .get("/Dashboard/numOfUsers", {
      params: {
        state: data?.location,
        month: (data?.startMonth || data?.endMonth) ? null : data?.month,
        year: data?.year,
        startMonth: data?.startMonth,
        endMonth: data?.endMonth,
      },
    })
    .then((response) => {
      console.log(response);
      dispatch(GetStaticsSuccess(response.data));
    })
    .catch((err) => {
      console.log(err);
      dispatch(GetStaticsFailed());
    });
};

export const getAllUsersDataAsync =
  (data, take, skip, CurrentPage) => (dispatch) => {
    dispatch(GetAlluserDetail());
    axiosInstance
      .get("/Dashboard/searchUserAccount", {
        params: {
          State: data?.location || null,
          page: CurrentPage || 1,
          perPage: take || 10,
          Type: data?.Type,
          month: (data?.startMonth || data?.endMonth) ? null : data?.month,
          year: data?.year,
          startMonth: data?.startMonth,
          endMonth: data?.endMonth,
        },
      })
      .then((response) => {
        console.log('response,,,,', response)
        response.data.CurrentPage = CurrentPage;
        dispatch(GetAllUserDetailSuccess(response?.data));
      })
      .catch((err) => {
        console.log(err);
        dispatch(GetAllUserDetailFailed());
      });
  };

  export const getAllBankingDataAsync = (data,bankingFilter) => (dispatch) => {
    console.log('data?.paymentMode',data,bankingFilter);
    dispatch(GetBankingDetail());
    axiosInstance
      .get("/Merchant/GetPaymentDetails", {
        params: {
          title: data?.title,
          page: data?.page,
          perPage: data?.perPage,
          type: data?.type,
          month: (data?.startMonth || data?.endMonth) ? null : data?.month,
          year: data?.year,
          startMonth: data?.startMonth,
          endMonth: data?.endMonth,
          paymentMode: data?.paymentMode,
          state:data.location
        },
      })
      .then((response) => {
        console.log("response??????????", response);
        response.data.CurrentPage = data?.page;
        response.data.bankingFilter = bankingFilter;
        dispatch(GetBankingDetailSuccess(response?.data));
        dispatch(getAllAdminBankingSuccess(response?.data));
      })
      .catch((err) => {
        console.log(err);
        dispatch(GetBankingDetailFailed());
      });
  };
  export const waivePenaltyAsync = (businessUserId,id,masterAdminUserId,adminName,ipAddress) => (dispatch) => {
    dispatch(WaivePenaltyLoading());
    console.log('calling waivePenaltyAsync',businessUserId);

    axiosInstance
      .post("/Paypal/waivePenalty", {
          businessUserId: businessUserId,
          masterAdminUserId: masterAdminUserId,
          adminName: adminName,
          ipAddress: ipAddress
      })
      .then((response) => {
        console.log('responseWaivePenalty', response);
        if(response?.data?.success){
          toast.success(response?.data?.message);
          const payloadWithRowId = { ...response.data, rowId: id };
          dispatch(WaivePenaltySuccess(payloadWithRowId));
        }else{
          dispatch(WaivePenaltyFailed(response?.data));
          toast.error(response?.data?.message)
        }
      })
      .catch((err) => {
        console.log('errWaivePenalty', err);
        dispatch(WaivePenaltyFailed(err));
        toast.error(err?.data?.message)
      });
  };

  export const getAllBankingStatics = (data) => (dispatch) => {
    console.log('request data getAllBankingStatics',data);
    
    dispatch(GetBankingStatatics());
    axiosInstance
      .get("/Merchant/getPaymentDetailsStatistics", {
        params: {
          month: (data?.startMonth || data?.endMonth) ? null : data?.month,
          year: data?.year,
          startMonth: data?.startMonth,
          endMonth: data?.endMonth,
          state:data.location,
          paymentMethod : data?.paymentMethod,
        },
      })
      .then((response) => {
        console.log('response>>>>>>>>>>>>>>>>>>', response)
        dispatch(GetBankingStataticsSuccess(response?.data));
      })
      .catch((err) => {
        console.log('err>>>>>>>>>>>>>>>>>>', err)
        dispatch(GetBankingStataticsFailed(err));
      });
  };
export const getPlatformFeeConfigAsync = () => (dispatch) => {
  dispatch(GetPlatformFeeConfigLoading());
  axiosInstance
    .get("/Merchant/PlatformFeeConfig")
    .then((response) => {
      dispatch(GetPlatformFeeConfigSuccess(response?.data));
    })
    .catch((err) => {
      console.log('errGetPlatformFeeConfig', err);
      dispatch(GetPlatformFeeConfigFailed(err));
    });
};

export const updatePlatformFeeConfigAsync = (enabled, adminId, adminName, ipAddress) => (dispatch) => {
  dispatch(UpdatePlatformFeeConfigLoading());
  axiosInstance
    .post("/Merchant/UpdatePlatformFeeConfig", { enabled, adminId, adminName, ipAddress })
    .then((response) => {
      dispatch(UpdatePlatformFeeConfigSuccess(response?.data));
      toast.success(
        response?.data?.platformFeeEnabled
          ? "Platform Fee enabled. The 12% fee will now apply."
          : "Platform Fee disabled. Platform Fee is now $0.00."
      );
    })
    .catch((err) => {
      console.log('errUpdatePlatformFeeConfig', err);
      dispatch(UpdatePlatformFeeConfigFailed());
      toast.error(err?.response?.data?.message || "Failed to update Platform Fee setting");
    });
};

// Action creators are generated for each case reducer function
export const {
  GetBankingStatatics,
  GetBankingStataticsSuccess,
  GetBankingStataticsFailed,
  GetStatics,
  GetStaticsSuccess,
  GetStaticsFailed,
  GetAlluserDetail,
  GetAllUserDetailSuccess,
  GetAllUserDetailFailed,
  GetBankingDetail,
  GetBankingDetailSuccess,
  GetBankingDetailFailed,
  getAllAdminSuccess,
  getAllAdminBankingSuccess,
  WaivePenaltyFailed,
  WaivePenaltySuccess,
  WaivePenaltyLoading,
  UserBlockUnBlock,
  GetPlatformFeeConfigLoading,
  GetPlatformFeeConfigSuccess,
  GetPlatformFeeConfigFailed,
  UpdatePlatformFeeConfigLoading,
  UpdatePlatformFeeConfigSuccess,
  UpdatePlatformFeeConfigFailed,
} = staticsSlice.actions;

export default staticsSlice.reducer;
